import React from 'react';
import { connect } from 'react-redux';
import css from '../styles/footer.css';
const { Component } = React;

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <em>website by <a className="bfm-link" href="mailto:josh.cochran@programmingjosh.com">josh.cochran@programmingjosh.com</a></em>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

const FooterContainer = connect(mapStateToProps, mapDispatchToProps)(Footer);

export {Footer, FooterContainer};



// WEBPACK FOOTER //
// ./app/screens/App/components/footer.js